module.exports = __webpack_public_path__ + "img/lectorasdatos.e3325cd1.png";